import React, { useEffect, useState } from 'react';
import { Box, MenuItem } from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../icons-lib';
import i18n from '../../../i18';
import Scrollbar from '../../../components/scrollbar/Scrollbar';
import { RangeValue } from '../../../components/range/RangeValue';
import { formatRangeValueFilter } from '../../../utils/formatRangeValue';
import useDebounce from '../../../hooks/useDebounce';

export const FilterRange = ({
    selectedFilter,
    filters,
    field,
    onValueChange,
    onBack
}) => {
    const start =
        filters.find((f) => f.field === field.id && f.op === '>')?.value || '';
    const end =
        filters.find((f) => f.field === field.id && f.op === '<')?.value || '';

    const [localFromValue, setLocalFromValue] = useState(start);
    const [localToValue, setLocalToValue] = useState(end);

    const debouncedFromValue = useDebounce(localFromValue, 500);
    const debouncedToValue = useDebounce(localToValue, 500);

    useEffect(() => {
        if (start !== localFromValue) {
            setLocalFromValue(start);
        }
        if (end !== localToValue) {
            setLocalToValue(end);
        }
    }, [start, end]);

    useEffect(() => {
        const filterData = formatRangeValueFilter(
            localFromValue,
            localToValue,
            field.id
        );
        onValueChange(filterData);
    }, [debouncedFromValue, debouncedToValue]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 1,
                maxWidth: '100%',
                overflow: 'hidden',
                p: 0
            }}
        >
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${selectedFilter.label}`)}
            </MenuItem>
            <Scrollbar sx={{ maxHeight: 300 }}>
                <RangeValue
                    fromValue={localFromValue}
                    toValue={localToValue}
                    handleChangeToValue={(e) => setLocalToValue(e.target.value)}
                    handleChangeFromValue={(e) =>
                        setLocalFromValue(e.target.value)
                    }
                    fromSymbol={field.unit}
                    toSymbol={field.unit}
                />
            </Scrollbar>
        </Box>
    );
};
